import { LOCALE_ID, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { ComponentsModule } from './components/components.module';
import {
  HashLocationStrategy,
  LocationStrategy,
  registerLocaleData,
} from '@angular/common';
import localeFr from '@angular/common/locales/fr';
import { APP_CONFIG } from '../../../../libs/app-config';
import { environment } from '../environments/environment';
import {
  provideNgxWebstorage,
  withNgxWebstorageConfig,
  withLocalStorage,
} from 'ngx-webstorage';
import { HttpCacheInterceptorModule } from '@ngneat/cashew';
import {
  AuthInterceptor,
  SchedulerAuthInterceptor,
} from '@pulpo/pulpo-commons';
import { RouteReuseStrategy } from '@angular/router';
import { CustomReuseStrategy } from '@pulpo/pulpo-api';
import { ServiceWorkerModule } from '@angular/service-worker';

registerLocaleData(localeFr);
@NgModule({
  declarations: [AppComponent],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    ComponentsModule,
    BrowserAnimationsModule,
    HttpCacheInterceptorModule.forRoot(),

    NgbModule,
    // Disabled outright (not just in dev) - this is a technical/debug tool
    // iterated on rapidly, and the SW was caching bundles across deploys,
    // making fixed bugs look like they were still happening on staging.
    // `enabled: false` also makes Angular unregister any SW a browser had
    // already installed from before this change.
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: false,
    }),
  ],
  providers: [
    provideNgxWebstorage(
      withNgxWebstorageConfig({ prefix: 'pulpo', separator: '-' }),
      withLocalStorage()
    ),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: SchedulerAuthInterceptor,
      multi: true,
    },
    {
      provide: LocationStrategy,
      useClass: HashLocationStrategy,
    },
    {
      provide: APP_CONFIG,
      useValue: environment,
    },
    { provide: LOCALE_ID, useValue: 'fr-FR' },
    {
      provide: RouteReuseStrategy,
      useClass: CustomReuseStrategy,
    },
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class AppModule {}
